import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form'
import FieldInput from '../../../components/FieldInput';
import { ErrorMessage } from '../../../components/UtilComponent';

export const FormAgricultor =
    ({ handleSubmit, pristine, reset, submitting, heading, handleSave, handleCancel }) => {

        return <Form onSubmit={handleSubmit(handleSave)}>
            <Form.Row>
                <Form.Group as={Col}>
                    <Field
                        TypeOf={Form.Control}
                        id="nome"
                        focus={true}
                        type="text"
                        name="nome"
                        label="Nome *"
                        placeholder="Nome do cliente"
                        component={FieldInput}
                    />
                </Form.Group>
                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="apelido"
                        type="text"
                        name="apelido"
                        label="Apelido *"
                        placeholder="Apelido do cliente"
                        component={FieldInput}
                    />
                </Form.Group>

            </Form.Row>

            <Form.Row>
                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="fazenda"
                        type="text"
                        name="fazenda"
                        label="Fazenda"
                        placeholder="Fazenda"
                        component={FieldInput}
                    />
                </Form.Group>
                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="telefone"
                        type="text"
                        name="telefone"
                        label="Telefone"
                        placeholder="Telefone"
                        component={FieldInput}
                    />

                </Form.Group>
                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="cpf_cnpj"
                        type="text"
                        name="cpf_cnpj"
                        label="CPF"
                        placeholder="CPF"
                        component={FieldInput}
                    />

                </Form.Group>


            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="dataNascimento"
                        type="date"
                        name="data_nascimento"
                        label="Data Nascimento"
                        placeholder="Data Nascimento"
                        component={FieldInput}
                    />

                </Form.Group>

                <Form.Group as={Col}>
                    <Field
                        TypeOf={Form.Control}
                        id="email"
                        type="email"
                        name="email"
                        label="Email"
                        placeholder="Email do cliente"
                        component={FieldInput}
                    />
                </Form.Group>
            </Form.Row>
            {/* <Form.Row>


                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="estadoCivil"
                        type="text"
                        name="estado_civil"
                        label="Estado Civil"
                        placeholder="Estado Civil do agricultor"
                        component={FieldInput}
                    />
                </Form.Group>
                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="grauInstrucao"
                        type="text"
                        name="grau_instrucao"
                        label="Grau Instrução"
                        placeholder="Grau Instrução"
                        component={FieldInput}
                    />

                </Form.Group>

            </Form.Row> */}


            <Form.Row>
                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="logradouro"
                        type="text"
                        name="logradouro"
                        label="Logradouro"
                        placeholder="Logradouro"
                        component={FieldInput}
                    />
                </Form.Group>
            </Form.Row>

            <Form.Row>
                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="cidade"
                        type="text"
                        name="cidade"
                        label="Cidade"
                        placeholder="Cidade"
                        component={FieldInput}
                    />
                </Form.Group>

                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="cep"
                        type="text"
                        name="cep"
                        label="CEP"
                        placeholder="CEP"
                        component={FieldInput}
                    />
                </Form.Group>
                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="numero"
                        type="text"
                        name="numero"
                        label="Número"
                        placeholder="Número"
                        component={FieldInput}
                    />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>

                    <Field
                        TypeOf={Form.Control}
                        id="ponto_referencia"
                        type="text"
                        name="ponto_referencia"
                        label="Ponto de Referência"
                        placeholder="Ponto de Referência"
                        component={FieldInput}
                    />
                </Form.Group>
            </Form.Row>
            <Form.Row >
                <Col>


                    <Button variant="secondary" className="btn-danger btn-sm" onClick={handleCancel}>
                        Cancelar
                    </Button>

                    {
                        heading === 'Adicionar' &&
                        <Button variant="secondary" disabled={pristine || submitting} onClick={reset} className="btn-space btn-sm">
                            Limpar Valores
                            </Button>

                    }
                </Col>
                <Col className="text-right">
                    <Button type="submit" disabled={submitting} className="btn-sm">
                        Salvar
                    </Button>
                </Col>
            </Form.Row>
        </ Form>

    }



const validate = values => {
    const errors = {};

    if (!values.nome) {
        errors.nome = `Este campo é obrigatório.`;
    }

    if (!values.apelido) {
        errors.apelido = `Este campo é obrigatório.`;
    }

    if (!values.logradouro) {
        errors.logradouro = `Este campo é obrigatório.`;
    }
    if (!values.cidade) {
        errors.cidade = `Este campo é obrigatório.`;
    }

    return errors;
};


FormAgricultor.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    heading: PropTypes.string.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
};


export default reduxForm({
    form: 'FormAgricultor',
    validate
})(FormAgricultor);